import { render } from "./SendToken.vue?vue&type=template&id=1e3879bf"
import script from "./SendToken.vue?vue&type=script&lang=js"
export * from "./SendToken.vue?vue&type=script&lang=js"

import "./SendToken.vue?vue&type=style&index=0&id=1e3879bf&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__